import type { ReactNode } from "react";
import { useMemo, useContext } from "react";

import { useRetrieveCompanySlug } from "../../iframe";
import { CubeContext } from "../context";

/**
 * @name CubeContextProvider
 * - Handles global state and setup related to the cube context
 * - Provides a context accessed via `useCubeContext()`
 */
export const CubeContextProvider = ({ children }: { children: ReactNode }) => {
  const cubeCompanySlug = useRetrieveCompanySlug();

  const contextValue = useMemo(
    () => ({
      cubeCompanySlug,
    }),
    [cubeCompanySlug],
  );

  return (
    <CubeContext.Provider value={contextValue}>{children}</CubeContext.Provider>
  );
};

export const useCubeContext = () => useContext(CubeContext);
